export default __webpack_public_path__ + "static/media/V410MANB5.8edd2ce5.pdf";